import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const inquiryApi = createApi({
  reducerPath: 'inquiryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/inquiry/`,
  }),
  endpoints: (builder) => ({
    getInquiry: builder.query({
      query: () => ({
        url: `unreply`,
      })
    })
  }),
})

export const { useGetInquiryQuery } = inquiryApi